export const PAPER_TOWEL = 'Paper Towel';
export const TOILET_PAPER = 'Toilet Paper';
export const SOAP = 'Soap';
export const AIR_FRESHENER = 'Air Freshener';
export const HAND_SANITIZER = 'Hand Sanitizer';
export const TOILET_PRODUCT = 'Toilet Product';
